import styled from "styled-components";

export const OuterContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.charcoalgrey};
  
  .title {
    color: ${({ theme }) => theme.colors.lilac};
  }
  
  .form-section {
    .form-label {
      color: ${({ theme }) => theme.colors.porcelaine};
    }
    
    .form-text {
      color: ${({ theme }) => theme.colors.porcelaine};
    }
    
    .form-button {
      background: ${({ theme }) => theme.colors.lilac} !important;
      color: ${({ theme }) => theme.colors.charcoalgrey} !important;
      margin-top: 14px;
    }
    
    .form-button:hover {
      background: ${({ theme }) => theme.colors.darklilac} !important;
      color: ${({ theme }) => theme.colors.lilac} !important;
    }
    
    .privacy-link-mobile {
      color: ${({ theme }) => theme.colors.porcelaine};
    }
  }
`;